import Task1 from 'models/task1';

const initialState = new Task1({});
export const UPDATE_DUE_DATE = 'UPDATE_DATE';
export const UPDATE_TO = 'UPDATE_TO';
export const UPDATE_EDITOR_STATE = 'UPDATE_EDITOR_STATE';
export const UPDATE_TASK = 'UPDATE_TASK';
export const UPDATE_TEAM_ID = 'UPDATE_TEAM';
export const UPDATE_COMPLETION_DATE = 'UPDATE_COMPLETION_DATE';
export const ADD_TO = 'ADD_TO';
export const REMOVE_TO = 'REMOVE_TO';

export function removeEmployeeFromTask(task, removableEmployeeId) {
  const newTask = { ...task };
  const toIds = task.toIds.filter((employee) => employee.id !== removableEmployeeId);
  newTask.toIds = toIds;
  return newTask;
}

// if the employee doesn't exist then only the employee would be added
export function addEmployeeToTask(task, toAddEmployee) {
  const toIds = [...task.toIds];
  const index = toIds.findIndex((employee) => employee.id === toAddEmployee.id);
  // employee doesn't already exist, add
  if (index === -1) toIds.push({ ...toAddEmployee });
  return { ...task, toIds };
}

export default function currentTaskReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TASK: {
      // console.log('normalized task', normalize(action.task, taskSchema));
      return { ...state, ...action.task };
    }
    case UPDATE_EDITOR_STATE: {
      return { ...state, editorState: action.editorState };
    }
    case UPDATE_TO:
      // since toIds will contain employees and it will be deep nesting
      // make sure that it doesn't duplicate
      const toIds = action.toIds || [];
      return { ...state, toIds: [...toIds] };
    case UPDATE_DUE_DATE:
      const { dueDate, coloredDueDate } = action.payload;
      return { ...state, dueDate, coloredDueDate };
    // See what should happen about updating teamName
    case UPDATE_TEAM_ID:
      return { ...state, teamId: action.teamId };
    case UPDATE_COMPLETION_DATE:
      return { ...state, completionDate: action.completionDate };
    case ADD_TO: {
      return addEmployeeToTask(state, action.to);
      // const toIds = [...state.toIds];
      // const index = toIds.findIndex(employee => employee.id === action.to.id);
      // if (index === -1) toIds.push({ ...action.to });
      // return { ...state, toIds };
    }
    case REMOVE_TO: {
      return removeEmployeeFromTask(state, action.toId);
      // const newState = { ...state };
      // const toIds = state.toIds.filter(employee => employee.id !== action.toId);
      // newState.toIds = toIds;
      // return newState;
    }
    default:
      return state;
  }
}

export const getUpdateFuctions = (dispatch) => {
  const updateDueDate = ({ dueDate, coloredDueDate }) => {
    dispatch({
      type: UPDATE_DUE_DATE,
      payload: {
        dueDate,
        coloredDueDate,
      },
    });
  };

  const updateTeamId = (teamId) => {
    dispatch({ type: UPDATE_TEAM_ID, teamId });
  };

  const updateToIds = (toIds = []) => {
    dispatch({ type: UPDATE_TO, toIds });
  };

  const updateEditorState = (editorState) => {
    dispatch({ type: UPDATE_EDITOR_STATE, editorState });
  };

  const updateTask = (task) => {
    dispatch({ type: UPDATE_TASK, task });
  };

  const updateCompletionDate = (completionDate) => {
    dispatch({ type: UPDATE_COMPLETION_DATE, completionDate });
  };

  const addTo = (to) => {
    dispatch({ type: ADD_TO, to });
  };

  const removeTo = (to) => {
    dispatch({ type: REMOVE_TO, toId: to.id });
  };

  return {
    updateDueDate,
    updateTeamId,
    updateToIds,
    updateEditorState,
    updateTask,
    updateCompletionDate,
    addTo,
    removeTo,
  };
};

const normalizedTask = {
  entities: {
    teams: {
      26: {
        id: '26',
        name: 'Team1',
        userRole: 'EMPLOYEE',
        teamType: 'DEFAULT',
      },
      28: {
        id: '28',
        name: 'Test8',
        userRole: 'MANAGER',
        teamType: 'OTHER',
      },
      29: {
        id: '29',
        name: 'Test9',
        userRole: 'MANAGER',
        teamType: 'OTHER',
      },
      31: {
        id: '31',
        name: 'Test11',
        userRole: 'MANAGER',
        teamType: 'OTHER',
      },
      53: {
        id: '53',
        name: 'sakshitest1',
        userRole: 'MANAGER',
        teamType: 'OTHER',
      },
      54: {
        id: '54',
        name: 'sakshitest2',
        userRole: 'MANAGER',
        teamType: 'OTHER',
      },
      78: {
        id: '78',
        name: 'Mesh Up',
        userRole: 'EMPLOYEE',
        teamType: 'OTHER',
      },
      735: {
        id: '735',
        name: 'VM',
        userRole: 'MANAGER',
        teamType: 'OTHER',
      },
      768: {
        id: '768',
        name: 'Personal',
        userRole: 'MANAGER',
        teamType: 'PERSONAL',
      },
      2853: {
        id: '2853',
        name: 'Business delevelopment',
        userRole: 'MANAGER',
        teamType: 'OTHER',
      },
    },
    users: {
      130: {
        selfExpressions: [],
        id: '130',
        fullName: 'sakshi Arora',
        firstName: 'sakshi',
        lastName: 'Arora',
        gender: null,
        designation: '',
        department: '',
        location: '',
        tenure: null,
        email: 'sakshi@datamonk.co',
        displayName: 'sakshi Arora',
        profilePhotoSrc: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultPhoto-19.png',
        money: {
          allocated: 856,
        },
        teams: ['26', '28', '31', '78', '29', '768', '54', '53', '735', '2853'],
        lastUserEvent: 'ONBOARDING_COMPLETE',
        organization: {
          id: '1',
          name: 'datamonk.co',
        },
        label: 'sakshi Arora',
        value: '130',
        tagType: 'EMPLOYEE_NAME',
        image: 'https://media.mesh.ai/mesh/media/profilePhoto/defaultPhoto-19.png',
      },
    },
    tasks: {
      1473686: {
        id: '1473686',
        from: '130',
        to: '130',
        toIds: ['130'],
        text: '#{{attributes.orgTag.102.name}} ',
        macros: {
          employees: {},
          demographics: {
            TEAM: {
              78: {
                uuid: '78',
                displayName: 'Mesh Up',
                filterTagType: 'TEAM',
              },
            },
          },
          attributes: {
            money: null,
            sentiment: 'APPRECIATIVE',
            orgTag: {
              100: {
                uuid: '100',
                createdTS: 1586874274000,
                updatedTS: 1588271823000,
                name: 'androirdSprint14',
                displayName: 'androirdSprint14',
                imageUrl: null,
                tagType: 'MESH_TASK',
                team: {
                  uuid: '333',
                  organization: {
                    uuid: '1',
                    orgName: 'datamonk.co',
                    enterpriseOrg: true,
                  },
                  name: 'Team1',
                },
              },
              102: {
                uuid: '102',
                createdTS: 1586883068000,
                updatedTS: 1588271823000,
                name: 'androirdSprint14',
                displayName: 'androirdSprint14',
                imageUrl: null,
                tagType: 'MESH_TASK',
                team: {
                  uuid: '336',
                  organization: {
                    uuid: '1',
                    orgName: 'datamonk.co',
                    enterpriseOrg: true,
                  },
                  name: 'MyTeam',
                },
              },
            },
          },
        },
        createdDate: '2020-06-11T11:32:15.000Z',
        updatedDate: '2020-06-11T11:45:37.000Z',
        dueDate: null,
        completionDate: null,
        editorState: {
          _immutable: {
            allowUndo: true,
            currentContent: {
              entityMap: {
                0: '6',
              },
              blockMap: {
                t556: {
                  key: 't556',
                  type: 'unstyled',
                  text: '#androirdSprint14 ',
                  characterList: [
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: '6',
                    },
                    {
                      style: [],
                      entity: null,
                    },
                  ],
                  depth: 0,
                  data: {},
                },
              },
              selectionBefore: {
                anchorKey: 't556',
                anchorOffset: 0,
                focusKey: 't556',
                focusOffset: 0,
                isBackward: false,
                hasFocus: false,
              },
              selectionAfter: {
                anchorKey: 't556',
                anchorOffset: 0,
                focusKey: 't556',
                focusOffset: 0,
                isBackward: false,
                hasFocus: false,
              },
            },
            decorator: null,
            directionMap: {
              t556: 'LTR',
            },
            forceSelection: false,
            inCompositionMode: false,
            inlineStyleOverride: null,
            lastChangeType: null,
            nativelyRenderedContent: null,
            redoStack: [],
            selection: {
              anchorKey: 't556',
              anchorOffset: 0,
              focusKey: 't556',
              focusOffset: 0,
              isBackward: false,
              hasFocus: false,
            },
            treeMap: {
              t556: [
                {
                  start: 0,
                  end: 18,
                  decoratorKey: null,
                  leaves: [
                    {
                      start: 0,
                      end: 18,
                    },
                  ],
                },
              ],
            },
            undoStack: [],
          },
        },
        lastEditedBy: '130',
        detailedStatus: 'ONGOING',
        description: null,
        teamId: '78',
        teamName: 'Mesh Up',
        taskType: 'TASK',
        recurrenceDetails: null,
        parentTaskId: null,
        subTaskStats: {
          completed: 0,
          total: 0,
        },
        discussionCommentsCount: 1,
        isEditing: false,
      },
    },
  },
  result: '1473686',
};
